import React from "react";
import ReactPDF, { Image, Text, View, StyleSheet } from "@react-pdf/renderer";
import InvoiceTableHeader from "./InvoiceTableHeader";
import InvoiceTableRow from "./InvoiceTableRow";
import InvoiceTableFooter from "./InvoiceTableFooter";
import { styles } from "../GenericPdf/style";
import { SinglePdfHeaderType } from "../GenericPdf/constant";

type AppProps = {
  downloadRevenuesData: any;
  tableHeaders: SinglePdfHeaderType[];
  currencySign: string | undefined;
  isIgstPresent: boolean;
  isGstPresent: boolean;
  currencyShortForm: string | undefined;
};

const ItemDetails = ({
  downloadRevenuesData,
  tableHeaders,
  currencySign,
  isIgstPresent,
  isGstPresent,
  currencyShortForm,
}: AppProps) => {
  return (
    <View style={styles.tableContainer}>
      <InvoiceTableHeader
        tableHeaders={tableHeaders}
        isIgstPresent={isIgstPresent}
      />
      <InvoiceTableRow
        items={downloadRevenuesData?.item_details}
        tableHeaders={tableHeaders}
        isIgstPresent={isIgstPresent}
        currencySign={currencySign}
        isGstPresent={isGstPresent}
      />
      <InvoiceTableFooter
        items={downloadRevenuesData}
        currencySign={currencySign}
        currencyShortForm={currencyShortForm}
        signature={
          downloadRevenuesData?.primary_details?.business_address_details
            ?.signature
        }
      />
    </View>
  );
};

export default ItemDetails;